import React, { useCallback } from "react";
import BuyPropertyCard from "../components/common/buy-property-card";
import { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowUpShortWide,
  faBorderAll,
  faList,
  faClose,
} from "@fortawesome/free-solid-svg-icons";

import PropertyFilter from "../components/common/PropertyFilter";
import buymoduleService from "../services/BuyModule-service/buy-module-service";
import { Button, Col, Container, Dropdown, Modal, Row } from "react-bootstrap";
import { ProgressSpinner } from "primereact/progressspinner";
import Pagination from "../components/common/Pagination";
import { Link, useLocation, useSearchParams } from "react-router-dom";

import { isNumber, isString, isArray, iteratee } from "lodash";
import { useUser } from "../components/context/UserContext";
import { useLoginModal } from "../components/context/LoginPopUpContext";
import BuyPropertyCardSkeleton from "../components/common/buy-property-card-skeliton";
// import { Search } from "lucide-react";

const BuyPropertyList = ({ propertyId }) => {
  const [isGridView, setIsGridView] = useState(true);
  const [isFilterOpen, setFiltersOpen] = useState(false);
  const [cPage, setCPage] = useState(1);
  const [pageS, setPageS] = useState(16);

  //this state is used to store the properties list
  const [properties, setProperties] = useState([]);
  const [lodingProperties, setLoadingProperties] = useState(false);

  // this functionality is used to set the filter option in url and accesss the filters from url
  // use full bookmark and share the url
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search); // take the query from url
  const queryPramasObj = Object.fromEntries(queryParams.entries()); // convert it into object - to help easy acess
  // this hook is used to  read and write the url
  const [searchParams, setSearchParams] = useSearchParams();

  // function update the url when the filter is selected  by user
  const updatesearchParams = (filters) => {
    const params = new URLSearchParams();

    Object.entries(filters).forEach(([key, value]) => {
      if (value && value !== "" && value !== 0 && key !== "filterPricemax") {
        params.set(key, value);
      }
    });

    setSearchParams(params);
  };

  // this is used to format the filter price range to k Lakh And Cr
  const formatPrice = (value) => {
    if (value >= 10000000) {
      return (value / 10000000).toFixed(1).replace(".0", "") + " Cr";
    } else if (value >= 100000) {
      return (value / 100000).toFixed(1).replace(".0", "") + " Lakh";
    }
    return value;
  };

  // this state is used to store the filters
  const [filters, setFilters] = useState({
    search: queryPramasObj.search || "",
    type: queryPramasObj.type || "",
    bhk: queryPramasObj.bhk || "",
    filterPricemax: formatPrice(Number(queryPramasObj.priceMax)) || "",
    priceMin: Number(queryPramasObj.priceMin) || 0,
    priceMax: Number(queryPramasObj.priceMax) || 0,
    status: queryPramasObj.status || "",
    listingType: queryPramasObj.listingType || "",
    seller: queryPramasObj.seller || "",
    propertyType: queryPramasObj.propertyType || "",
    age: queryPramasObj.age || "",
    floor: queryPramasObj.floor || "",
    areaMin: Number(queryPramasObj.areaMin) || 0,
    areaMax: Number(queryPramasObj.areaMax) || 0,
    sort: queryPramasObj.sort || "",
  });

  // below three fuction are used to update the filters state when the filter option clicked
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const handleRangeChange = (name, value) => {
    setFilters((prev) => ({ ...prev, [name]: value }));
  };
  const buttonclick = (name, value) => {
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  // this function to clear the only selected filter

  const clearSelectedFilter = (name, value) => {
    if (isString(value)) {
      setFilters((prev) => ({ ...prev, [name]: "" }));
    }
    if (isNumber(value)) {
      setFilters((prev) => ({ ...prev, [name]: 0 }));
    }
    if (isArray(value)) {
      setFilters((prev) => ({ ...prev, [name]: [] }));
    }
    if (name === "filterPricemax") {
      setFilters((prev) => ({ ...prev, ["priceMax"]: 0 }));
    }
  };
  // here clear the all filters
  const clearAllFilter = () => {
    setFilters({
      search: "",
      type: "",
      bhk: "",
      filterPricemax: "",
      priceMin: 0,
      priceMax: 0,
      status: "",
      listingType: "",
      seller: "",
      propertyType: "",
      age: "",
      floor: "",
      areaMin: 0,
      areaMax: 0,
      sort: "",
    });
    setCPage(1);
    setSearchParams({});
  };

  //using useCallback to avoid Unwanted infine loop rendring
  const fetchPropertylist = useCallback(
    async (cPage = 1) => {
      const payload = {
        pageSize: pageS,
        pageNo: cPage,
        searchParam: filters.search,
        type: filters.type,
        minPrice: filters.priceMin,
        maxPrice: filters.priceMax == 0 ? 100000000 : filters.priceMax,
        fromFloor:
          Number(filters.floor == "12+" ? 12 : filters.floor.split("-")[0]) ||
          null,
        toFloor: Number(filters.floor?.split("-")[1]?.split(" ")[0]) || null,
        bhkType: filters.bhk,
        listingType: filters.listingType,
        sellerType: filters.seller,
        propertyType: filters.propertyType,
        minAge:
          Number(
            filters.age === "10+ Years" ? 10 : filters.age.split("-")[0],
          ) || null,
        maxAge: Number(filters.age?.split("-")[1]?.split(" ")[0]) || null,
        minArea: 500,
        maxArea: filters.areaMax == 0 ? 10000 : Number(filters.areaMax) || 0,
        constructionStatus: filters.status,
        sortBy: filters.sort,
      };

      setLoadingProperties(true);

      try {
        const response = await buymoduleService.buyPropertiesList(payload);
        setProperties(response.data.result || []);
        // console.log(response);
      } catch (error) {
        // console.log(error);
      } finally {
        setLoadingProperties(false);
      }
    },
    [filters],
  );

  //in this use effect call the api with the changed value then update to the list of properties
  useEffect(() => {
    // console.log("filters after changing the values:", filters);
    updatesearchParams(filters);

    fetchPropertylist();
  }, [fetchPropertylist]);

  //when user clicks different page
  const handlePageChange = (newPage) => {
    setCPage(newPage);
    fetchPropertylist(newPage);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  //this function to open the filter for mobile
  const openFilter = () => {
    setFiltersOpen(true);
  };

  //convert the filter to array
  const filterArray = Object.entries(filters).map(([key, value]) => ({
    key,
    value,
  }));

  return (
    <>
      <section className="property-listing-buy property-listing-section">
        <div className="container">
          <div className="row">
            <div className=" col-lg-3 col-md-4 col-sm-4 ">
              <div className=" mobile-d-none">
                {/* // this is because when the mobile model is open remove this block from code other wise the radio button will not work because of same name */}
                {!isFilterOpen && (
                  <PropertyFilter
                    filters={filters}
                    OnRangeChange={handleRangeChange}
                    OnInputChange={handleInputChange}
                    buttonClick={buttonclick}
                    ClearAllfilter={clearAllFilter}
                    clearSelectedFilter={clearSelectedFilter}
                  />
                )}
              </div>
            </div>
            <div className="col-lg-9 col-md-8 col-sm-8">
              <div className="property-list-title buy-module-list">
                <div className="Head-result">
                  <h1 className="text-capitalize">
                    Properties for sale in{" "}
                    {filters.search ? filters.search : "Bangalore"}
                  </h1>
                  <p>Showing {properties[0]?.totalCount} results</p>
                </div>
                <div className="buy-property-sorting-wrap">
                  <div className="sorting-dropdown">
                    <Dropdown>
                      <Dropdown.Toggle
                        variant="success"
                        id="dropdown-basic"
                        className="sort-btn"
                      >
                        Sort By <FontAwesomeIcon icon={faArrowUpShortWide} />
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        <Dropdown.Item
                          onClick={() =>
                            setFilters((prev) => ({ ...prev, sort: "L2H" }))
                          }
                        >
                          Price: Low to High
                        </Dropdown.Item>

                        <Dropdown.Item
                          onClick={() =>
                            setFilters((prev) => ({ ...prev, sort: "H2L" }))
                          }
                        >
                          Price: High to Low
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                  <div className="more-filter-option">
                    <button className="filter-btn" onClick={openFilter}>
                      <span> Filters</span>
                      <svg
                        aria-hidden="true"
                        focusable="false"
                        data-prefix="fas"
                        data-icon="filter"
                        class="svg-inline--fa fa-filter "
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"
                      >
                        <path
                          fill="currentColor"
                          d="M3.9 54.9C10.5 40.9 24.5 32 40 32l432 0c15.5 0 29.5 8.9 36.1 22.9s4.6 30.5-5.2 42.5L320 320.9 320 448c0 12.1-6.8 23.2-17.7 28.6s-23.8 4.3-33.5-3l-64-48c-8.1-6-12.8-15.5-12.8-25.6l0-79.1L9 97.3C-.7 85.4-2.8 68.8 3.9 54.9z"
                        ></path>
                      </svg>
                    </button>
                  </div>
                  <div className="grid-view-option">
                    <ul>
                      <li
                        className={isGridView ? "active" : ""}
                        onClick={() => setIsGridView(true)}
                      >
                        <FontAwesomeIcon icon={faBorderAll} />
                        Grid View
                      </li>
                      <li
                        className={!isGridView ? "active" : ""}
                        onClick={() => setIsGridView(false)}
                      >
                        <FontAwesomeIcon icon={faList} />
                        List View
                      </li>
                    </ul>
                  </div>
                </div>
                {/* this will display the applied filters only for mobile */}
                <div className="buy-applied-filter-mobile pt-1 ">
                  <ul className="mobile-filters Applied-filters d-flex flex-wrap">
                    {filterArray
                      .filter((item) => item.value && item.key !== "priceMax")
                      .map((item) => (
                        <li key={item.key}>
                          {item.value === "H2L"
                            ? "High To Low"
                            : item.value === "L2H"
                              ? "Low To High"
                              : item.key === "filterPricemax"
                                ? `${item.value} Max Price`
                                : item.key === "priceMin"
                                  ? `${item.value} Price`
                                  : item.key === "areaMax"
                                    ? `${item.value} max Sqft`
                                    : item.key === "floor"
                                      ? `${item.value} Floor`
                                      : item.value}
                          <span>
                            <FontAwesomeIcon
                              icon={faClose}
                              className="clear-filter-btn"
                              onClick={() =>
                                clearSelectedFilter(item.key, item.value)
                              }
                            />
                          </span>
                        </li>
                      ))}
                  </ul>
                </div>
              </div>
              <div
                className={`property-card__row buy-property-row row-gap-gutter ${
                  !isGridView ? "property-list-view" : ""
                }`}
              >
                {/* listing properties here */}
                {lodingProperties ? (
                  // <div className="min-h-300 mx-auto">
                  //   <ProgressSpinner
                  //     style={{ width: "50px", height: "50px" }}
                  //     strokeWidth="3"
                  //     fill="var(--surface-ground)"
                  //     animationDuration=".5s"
                  //   />
                  // </div>
                  <div className="row w-100">
                    {[1, 2, 3, 4, 5, 6, 7].map((item) => (
                      <div className="col-4" key={item}>
                        <BuyPropertyCardSkeleton />
                      </div>
                    ))}
                  </div>
                ) : properties.length > 0 ? (
                  properties.map((property) => (
                    <div
                      className="property-card__col buy-listing-page"
                      key={property.id}
                    >
                      <BuyPropertyCard
                        key={property.id}
                        property={property}
                        flatId={property.id}
                      />
                    </div>
                  ))
                ) : (
                  <div className="text-center w-100 pt-5">
                    <div className="text-center py-5">
                      <img
                        src="/property-not-found.png" // Replace with your image path
                        alt="No Properties Found"
                        style={{ maxWidth: "250px", width: "100%" }}
                      />

                      <div className="d-flex justify-content-center mt-4">
                        <Link to="/" className="btn btn-primary">
                          Go Back Home
                        </Link>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          {properties.length > 0 && (
            <Col lg={12}>
              <div className="grid-pagination">
                <Pagination
                  onPageChange={handlePageChange}
                  pageS={pageS}
                  cPage={cPage}
                  pCount={properties[0]?.totalCount}
                />
              </div>
            </Col>
          )}
        </div>
        {isFilterOpen && (
          <div className="mobile-filter-modal">
            <div
              className="modal-backdrop"
              onClick={() => setFiltersOpen(false)}
            ></div>

            <div className="modal-content-box">
              <div className="modal-header d-flex px-3  align-items-center">
                <h4 className="model-heading">Filters</h4>
                <button
                  className="btn close-btn text-danger"
                  onClick={() => setFiltersOpen(false)}
                >
                  x
                </button>
              </div>

              <div className="modal-body">
                <PropertyFilter
                  filters={filters}
                  OnRangeChange={handleRangeChange}
                  OnInputChange={handleInputChange}
                  buttonClick={buttonclick}
                  ClearAllfilter={clearAllFilter}
                  clearSelectedFilter={clearSelectedFilter}
                />
              </div>
            </div>
          </div>
        )}
      </section>
    </>
  );
};

export default BuyPropertyList;
